import Services from './Services'

export default class Lead extends Services {
  constructor() {
    super()
  }

  async saveLead(nome, celular, comentarios, idVeiculo, nomeVeiculo, donoDoLead, empresa, tipoOrigem) {
    let tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)

    const data = {
      status: 'Pendente',
      nomeVeiculo,
      termometro: 'SuperQuente',
      empresa,
      formaDePagamento: 'Consorcio',
      celular,
      origem: 'flyVendas-Form',
      tipoOrigem,
      nome,
      idVeiculo,
      dataProxContato: tomorrow.toISOString().substr(0, 10),
      comentarios: comentarios || 'Entrar em contato com cliente',
      donoDoLead,
      descricao: 'Lead criado pelo formulário do Flyvendas'
    }

    try {
      await this._http.post(`/leads/form`, data)
      return Promise.resolve()
    }
    catch (error) {
      return Promise.reject(error)
    }
  }
}
